//this module will be deleted, its only temporary
import React from "react";
import Video from "components/video";
import ButtonLink from "components/button-link";
import useTimer from "hooks/useTimer";
import CountdownTimer from "components/countdown-timer";
import { useSettings } from "hooks/useStore";
import Image from "components/image";
import clsx from "clsx";

const BannerVideo = ({ data }) => {
	const { desktopVideo, mobileVideo , label, secondLabel, cta, title, subtitle, footer, discountCode, mobileImage, desktopImage, 
		useImageBackground, removeBackgroundShadow, blackBackgroundDetails } = data;
	const timerData = data.countdownTimer || {};
	const { timer, active } = useTimer(timerData);
	const { isClient } = useSettings(["isClient"]);

	return (
		<div className="relative w-full">
			<div className="w-full">
				{useImageBackground ? (
					<Image image={desktopImage} className="w-full h-auto block !hidden md:!block" />
				) : (
					<div className="!hidden md:!block">
						<Video data={desktopVideo} autoplay className="w-full h-auto" />
					</div>
				)}
				<div className="w-full block md:hidden">
					{useImageBackground ? ( 
						<Image image={mobileImage} className="w-full h-full !min-h-fit block" />
					) : ( 
						<Video data={mobileVideo} autoplay loop muted showControls={false} className="w-full h-full !min-h-fit blockr"/>
					)}
				</div>

			</div>

			<div className="absolute inset-0 z-10">
				{!removeBackgroundShadow && (
					<>
						<div className="absolute inset-0 z-10 w-full h-full md:hidden" style={{
							backgroundImage:
							"linear-gradient(to bottom, black 0%, black 35% rgba(0,0,0,0.7) 50%, rgba(0,0,0,0.2) 70%, transparent 100%)",
						}} />
						<div className="absolute inset-0 z-10 w-full h-full hidden md:block" style={{
							backgroundImage:
						"linear-gradient(to right, black 0%, black 30%, rgba(0, 0, 0, 0.7) 50%, rgba(0, 0, 0, 0.2) 70%, transparent 100%)",
						}} />
					</>
				)}

				<div className="relative z-20 w-full px-5 sm:px-10 xxl:container-fluid-padding
				 xxl:p-0 text-white flex flex-col items-center justify-start md:flex-row md:items-center h-full">
					<div
						className={clsx( "lg:p-[5%] xxl:m-0 xxl:p-0 text-center md:text-left", 
							blackBackgroundDetails && "bg-black my-2 p-5 lg:!p-10" )}
					>
						<div className="sm:h-10 mb-2 sm:my-3 sm:mb-4 w-full text-center overflow-hidden">
							{label && (
								<div
									className={clsx( "label-base opacity-100 bg-beige sm:!w-full !w-[85%] text-black", 
										blackBackgroundDetails && "bg-black text-white" )}
								>
									{label}
								</div>
							)}
							{secondLabel && (
								<div className="label-base animate-label-fade opacity-0 bg-black 
								text-beige border absolute top-0 left-1/2 -translate-x-1/2 sm:!w-full !w-[85%] delay-1s">
									{secondLabel}
								</div>
							)}
						</div>

						<div
							className={clsx(
								"flex flex-row md:flex-col items-baseline items-center md:items-start",
								"justify-center md:justify-start text-center md:text-left gap-2 md:gap-0",
								blackBackgroundDetails && "md:px-20 lg:px-10"
							)}
						>
							{title && ( <span className="font-prata text-beige text-4xl lg:text-h1 leading-none"> {title}</span> )}
							{subtitle && (
								<span className="font-header text-white text-4xl lg:text-h1 leading-none"> {subtitle}</span>
							)}
						</div>

						{discountCode && (
							<p
								className={clsx("md:font-poppins !py-1 sm:!py-3 font-bold sm:font-semibold text-center sm:text-lg pt-3", 
									!blackBackgroundDetails && "tracking-wide sm:tracking-[0.31em] md:text-left" )}
							>
								USE CODE &quot;
								<span
									className={clsx("text-beige !py-1 sm:!py-3 font-bold sm:font-semibold sm:text-lg md:font-poppins",
										!blackBackgroundDetails && "sm:tracking-[0.20em]"
									)} 
								> {discountCode}
								</span>
								&quot;
							</p>
						)}

						{active && isClient && (
							<div className="md:col-span-1 py-2 sm:py-0 ml-0 sm:ml-3 md:row-span-2 flex justify-center md:justify-center">
								<CountdownTimer timer={timer} compactView />
							</div>
						)}

						{cta && (
							<ButtonLink data={cta} className={clsx(
								"!font-extrabold sm:w-full w-[84%] px-0 md:px-0 mt-3 mb-3 text-white mx-auto md:mx-0",
								blackBackgroundDetails && "md:!w-[80%] md:!mx-10" )} />
						)}

						{footer && (
							<p className={clsx("sm:text-lg text-sm text-center md:text-left font-semibold",
								blackBackgroundDetails && "sm:!text-sm text-xs md:!px-[3rem]")} >
								{footer}
							</p>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BannerVideo;
